import { AvailableToPurchaseFlag } from '@/types/api';
import { IconInfoCircle } from '@/features/icons';
import { Modal } from '@/features/modal';
import { VariantContextType } from '@/app/(pdp)/context/types';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { cn } from '@/utils/cn';
import { toNumberCommas } from '@/utils/string-helpers';
import useModal from '@/utils/use-modal';
interface Props {
  contextType: VariantContextType;
}
export const GoldPricingDetail = ({
  contextType
}: Props) => {
  const {
    activeVariant
  } = useVariantContextValues(contextType);
  const {
    isModalOpen,
    handleOpenModal,
    handleCloseModal
  } = useModal();
  const isTwentyFourCaratGold = activeVariant?.flags?.includes(AvailableToPurchaseFlag.Gold24);
  const goldPriceLabel = isTwentyFourCaratGold ? 'قیمت روز یک گرم طلای ۲۴ عیار' : 'قیمت روز یک گرم طلای ۱۸ عیار';
  const goldPricingData = activeVariant?.goldBasePrice;
  const weight = activeVariant?.weight;
  if (!goldPricingData) return null;
  const dataRows = [{
    label: goldPriceLabel,
    value: `${toNumberCommas(goldPricingData.goldPrice || 0)} تومان`
  }, {
    label: 'وزن طلای به کار رفته',
    value: `${weight?.value} گرم`
  }, {
    label: 'اجرت ساخت',
    value: `${toNumberCommas(goldPricingData.makingFee || 0)} تومان (${goldPricingData.makingFeePercent}%)`
  }, {
    label: 'سود فروشنده',
    value: `${toNumberCommas(goldPricingData.margin || 0)} تومان (${goldPricingData.marginPercent}%)`
  }, {
    label: 'قیمت اجزای غیر طلا / حق ضرب',
    value: `${toNumberCommas(goldPricingData.nonGoldComponentCost || 0)} تومان`
  }, {
    label: 'مالیات',
    value: `${toNumberCommas(goldPricingData.vat || 0)} تومان (${goldPricingData.vatPercent}%)`
  }, {
    label: 'مجموع',
    value: `${toNumberCommas(activeVariant.basePrice || 0)} تومان`,
    className: 'font-bold'
  }];
  return <>
            <button onClick={handleOpenModal}>
                <IconInfoCircle className='h-4 w-4 text-text-darkGray lg:h-5 lg:w-5' data-sentry-element="IconInfoCircle" data-sentry-source-file="gold-pricing-detail.tsx" />
            </button>

            <Modal isOpen={isModalOpen} title='نحوه محاسبه قیمت' handleClose={handleCloseModal} displayType='withTopBar' width='w-full lg:max-w-sm' data-sentry-element="Modal" data-sentry-source-file="gold-pricing-detail.tsx">
                <div className='mt-6 flex flex-col rounded border border-border-gray-light px-2 py-3'>
                    {dataRows.map(({
          label,
          value,
          className
        }, index) => <div className={cn('grid grid-cols-2 border-solid border-border-gray-light px-1 py-2 text-caption-12 [&:not(:last-child)]:border-b', className)} key={index}>
                            <span className='text-text-darkGray'>{label}</span>
                            <span className='text-text-black'>{value}</span>
                        </div>)}
                </div>
            </Modal>
        </>;
};